<template>
    <div></div>
</template>

<script setup lang="ts">
    import {definePageMeta} from '@typed-router';

    definePageMeta({
        middleware: ['external-redirect'],
    });
</script>
